<template>
  <div>
    <loading-spinner v-if="slidesLoading" class="mt-2 d-block"/>
    <div class="w-100" />
    <drop-down
        v-if="!slidesLoading && slides && slides.length > 0"
        :images="thumbs"
        :initial-active-value="initialSlide"
        :labels="slideNames"
        :values="slides.map(item => item.id)"
        class="dark language-selector mt-2"
        @select="(value) => $emit('slideSelected', value)"
    />
  </div>
</template>

<script>
import DropDown from "@/components/forms/DropDown.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import vFormAndProjectMixin from "@/components/vForm/mixins/vFormAndProjectMixin.js.vue";

export default {
  name: "SlideSelector",
  components: {LoadingSpinner, DropDown},
  mixins: [vFormAndProjectMixin],
  props: {
    projectId: {
      type: String,
      required: true
    },
    initialSlide: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      slides: [],
      thumbs: [],
      slidesLoading: false
    }
  },
  computed: {
    slideNames() {
      if (this.slides && this.slides.length > 0) {
        return this.slides.map((slide, index) => {
          return `Slide ${index + 1}`;
        });
      }
      return [];
    },
  },
  watch: {
    projectId() {
      this.loadSlides();
    },
    initialSlide(newValue) {
      if (newValue && this.slides.length > 0) {
        this.$emit('slideSelected', newValue);
      }
    }
  },
  beforeMount() {
    this.loadSlides();
  },
  methods: {
    async loadSlides() {
      console.log('Loading slides for project', this.projectId);
      await this.loadProjectConfig();
      await this.loadThumbnails();
    },
    async loadProjectConfig() {
      const loadingMode = await this.getProjectLoadingMode(this.projectId);
      const projectConfig = await this.loadProjectConfigFileNew(this.projectId, {loadingMode});
      this.slides = projectConfig.slides || [];
    },
    async loadThumbnails() {
      this.slidesLoading = true;
      this.thumbs = [];
      const loadingMode = await this.getProjectLoadingMode(this.projectId);
      for (let i = 0; i < this.slides.length; i++) {
        const slide = this.slides[i];
        try {
          const imgBase64 = await this.loadThumbnailNew(this.projectId, slide, i, {
            loadingMode,
            mini: true,
            width: 100,
            height: 50
          });
          this.thumbs.push(imgBase64);
        } catch (e) {
          console.error('Could not load thumbnail for slide', slide.id, e);
        }
      }
      this.slidesLoading = false;
    },
  }
}
</script>

<style lang="scss" scoped>

</style>